import React from 'react';
import {Link} from 'react-router-dom';
// Navigation links
function Navigation() {
    return (
        /*vspeed database not used but may be used in future*/
        <nav className='App-nav'>
            <Link to="/">Home</Link>
            <Link to="/vsps">Vspeed</Link>
            <Link to="/rollout">Ground Roll</Link>
            
            <Link to="/wtbals">Weight & Bal.</Link>
            <Link to="/navlog">NavLog</Link>
            <Link to="/weather">Web Links</Link>
            
            
                    
        </nav>
    );
}
export default Navigation;
